import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

interface IFooterProps {
    initialValue: number | string;
    updateInitialValue: any;
}

const Footer: React.FC<IFooterProps> = ({ initialValue, updateInitialValue }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: '5px',
                width: '100vw',
                gap: '10px',
                backgroundColor: 'white',
                boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                position: 'sticky',
                alignItems: 'center',
                justifyContent: 'space-between',
                bottom: 0,
                zIndex: 1000
            }}
        >
            <TextField
                type="text"
                variant="standard"
                size="small"
                sx={{ width: '100%' }}
                value={initialValue != 0 ? initialValue : 0}
                placeholder="סכום תשלום(ש״ח)"
                onChange={(e) => {
                    const newValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(newValue)) updateInitialValue(newValue); // edit the value of that payment
                }}
            />

            <Button loading={false} disabled={false} sx={{ minWidth: '75vw' }} variant="contained">
                הנפק
            </Button>
        </Box>
    );
};

export default Footer;
